

























































import { Provide, Prop, Component, Vue } from 'vue-property-decorator'
import { gsap } from 'gsap'
import { Referral } from '@/api/model/referral'
import { ReferralAPI } from '@/api/backend-client'
import { AutoCloseSettings } from '@/api/model/auto-close-settings'
import ReferralDetailHeader from '@/views/Tasks/Detail/ReferralDetails/ReferralDetailHeader.vue'
import ReferralDetailSummary from '@/views/Tasks/Detail/ReferralDetails/ReferralDetailSummary.vue'
import ReferralDetailsTabs from '@/views/Tasks/Detail/ReferralDetails/ReferralDetailsTabs.vue'
import ReferralSidebar from '@/views/Tasks/Detail/ReferralSidebar.vue'
import CommentsPanel from '@/views/Tasks/Detail/ReferralDetails/CommentsPanel.vue'
import moment from 'moment'
import GreyPanel from '@/components/ui/blocks/GreyPanel.vue'
import Card from '@/components/ui/blocks/Card.vue'
import BlockContainer from '@/components/ui/blocks/BlockContainer.vue'

@Component({
    components: {
        BlockContainer,
        Card,
        GreyPanel,
        ReferralSidebar,
        ReferralDetailsTabs,
        ReferralDetailSummary,
        ReferralDetailHeader,
        CommentsPanel,
    },
})
export default class DetailVanilla extends Vue {
    @Prop({ required: true }) readonly referralId!: string
    referral: Referral = null
    loading: boolean = true

    async mounted() {
        await this.loadReferral()

        if (this.$route.name === 'tasks_detail') {
            this.$router.replace({
                name: this.referral.isEmmaAppraisal ? 'tasks_detail_emma_appraisal' : 'tasks_detail_future_address',
            })
        }
    }

    async loadReferral(): Promise<void> {
        this.loading = true
        this.referral = await ReferralAPI.get(this.referralId)

        if (!this.referral) {
            await this.$router.push({name: 'tasks_all'})
        }

        this.loading = false
    }

    @Provide()
    async reloadReferral(): Promise<void> {
        this.loading = true
        this.referral = await ReferralAPI.get(this.referralId, true)
        this.loading = false
    }

    @Provide()
    async saveReferral(referral: Referral): Promise<void> {
        this.referral = await ReferralAPI.update(this.referralId, referral)
    }

    async assignToMe(): Promise<void> {
        this.referral.assignedTo = this.$currentUser
        await this.saveReferral(this.referral)
        await this.reloadReferral()
    }

    get canEdit(): boolean {
        if (!this.$currentCompany || !this.referral || !this.referral.assignedToBranch) {
            return false
        }

        return this.$currentCompany.id === this.referral.assignedToBranch.company.id
    }

    get isEditable(): boolean {
        if (!this.referral || ['processed', 'closed'].includes(this.referral.status)) {
            return false
        }

        return true
    }

    get isAssigned(): boolean {
        return this.referral.assignedTo !== null
    }

    onCommentsChanged(comments): void {
        this.referral.comments = comments
    }

    get autoCloseSettings(): AutoCloseSettings|null {
        const autoCloseSettings = this.referral.assignedToBranch.company.autoCloseSettings
        if (!autoCloseSettings || !autoCloseSettings.closeEnabled) {
            return null
        }

        return autoCloseSettings
    }

    get autoCloseWarningVisible(): boolean {
        const autoCloseSettings = this.autoCloseSettings
        if (!autoCloseSettings) {
            return false
        }

        if (!this.canEdit || !this.isEditable) {
            return false
        }

        if (!this.referral || ['successful', 'processed', 'closed'].includes(this.referral.status)) {
            return false
        }

        const autoCloseNotificationDate = moment(this.referral.autoCloseNotificationDate)

        return autoCloseNotificationDate.isSameOrBefore({}, 'day')
    }

    get autoCloseWarningDays(): number {
        const autoCloseDate = moment(this.referral.autoCloseDate)

        return Math.max(0, Math.ceil(autoCloseDate.diff({}, 'days', true)))
    }

    animateContactShow(element: HTMLDivElement, onComplete: () => void): void {
        gsap.set(element, {
            opacity: 0,
            x: '-10vw',
        })

        gsap.to(element, {
            opacity: 1,
            x: 0,
            duration: .4,
            clearProps: true,
            onComplete,
        })
    }

    animateReferralShow(element: HTMLDivElement, onComplete: () => void): void {
        gsap.set(element, {
            opacity: 0,
            x: '-4vw',
        })

        gsap.to(element, {
            delay: .4,
            x: 0,
            opacity: 1,
            duration: .4,
            clearProps: true,
            onComplete,
        })
    }
}
